import { Group } from "@mantine/core"
import { OperationsAdminVenueTalentTabs } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentTabs"
import { EditOperationsAdminVenueTalentAction } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { OperationsAdminVenueTalentView } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentView"

export function OperationsAdminVenueTalent() {

    const { currentItem } = useAppState(state=>state.users)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.id}`}
                    renderAction={
                        <Group gap="sm">
                            <EditOperationsAdminVenueTalentAction />
                        </Group>
                    }
                />
            }
        >
            <OperationsAdminVenueTalentTabs/>
            <OperationsAdminVenueTalentView/>
        </PageLayout>
    )

}